/**
 * Carrier tracking-page URL builders, keyed case-insensitively by the raw
 * carrier string the OM-WISMO shipment response gives us. Returns undefined
 * for an unrecognized carrier or a missing tracking number — callers should
 * fall back to plain text in that case rather than a dead link.
 */
const TRACKING_URL_BUILDERS: Record<string, (trackingNumber: string) => string> = {
  FEDEX: (n) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(n)}`,
  UPS: (n) => `https://www.ups.com/track?loc=en_US&tracknum=${encodeURIComponent(n)}`,
  USPS: (n) => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(n)}`,
  DHL: (n) => `https://www.dhl.com/en/express/tracking.html?AWB=${encodeURIComponent(n)}`,
};

export function getTrackingUrl(carrier: string | undefined, trackingNumber: string | undefined): string | undefined {
  if (!carrier || !trackingNumber) return undefined;
  const builder = TRACKING_URL_BUILDERS[carrier.trim().toUpperCase()];
  return builder?.(trackingNumber);
}
